export default {
  assignedPaths: {
    show: "/people-team/assigned-paths/:id",
  },
  assignedActions: {
    show: "/people-team/scheduled-actions/:id",
  },
  activityFeed: {
    index: "/people-team/activity-feed",
  },
  planning: {
    index: "/people-team/planning",
    showType: "/people-team/planning/:type",
  },
  emailTemplates: {
    index: "/people-team/planning/emails",
    show: "/people-team/planning/emails/:id",
  },
  meetingTemplates: {
    index: "/people-team/planning/meetings",
    show: "/people-team/planning/meetings/:id",
  },
  messageTemplates: {
    index: "/people-team/planning/messages",
    show: "/people-team/planning/messages/:id",
  },
  taskTemplates: {
    index: "/people-team/planning/tasks",
    show: "/people-team/planning/tasks/:id",
  },
  checkpointTemplates: {
    index: "/people-team/planning/checkpoints",
    show: "/people-team/planning/checkpoints/:id",
  },
  customForms: {
    index: "/people-team/planning/forms",
    new: "/people-team/planning/forms/new",
    show: "/people-team/planning/forms/:id",
    preview: "/people-team/planning/forms/:id/preview",
  },
  messages: {
    index: "/messages",
  },
  legacyPaths: {
    index: "/people-team/paths",
    show: "/people-team/paths/:id",
  },
  templatePaths: {
    // index: "/people-team/template-paths",
    show: "/people-team/template-paths/:id",
  },
  templateActions: {
    // index: "/people-team/template-workflow-actions",
    show: "/people-team/template-actions/:id",
  },
  dashboard: "/people-team",
  stats: "/people-team/stats",
  workforce: "/people-team/workforce",
  groups: "/people-team/groups",
  taskGrid: "/people-team/task-grid",
  company: {
    settings: "/people-team/company/settings",
    info: "/people-team/company/settings/info",
    notifiers: "/people-team/company/settings/notifiers",
    nudgesSettings: "/people-team/company/settings/nudges",
    emailSettings: "/people-team/company/settings/email",
    calendarSettings: "/people-team/company/settings/calendar",
    ssoSettings: "/people-team/company/settings/sso",
    peopleTeamSettings: "/people-team/company/settings/people-team",
    taskSettings: "/people-team/company/settings/tasks",
    newHireExperienceSettings: "/people-team/company/settings/new-hire-experience",
    integrations: {
      index: "/people-team/company/integrations",
      show: "/people-team/company/integrations/:id",
      success: "/people-team/company/integration-success",
    },
  },
  issues: {
    base: "/people-team/issues",
    show: "/people-team/issues/:id",
    actions: "/people-team/issues/unsent",
  },
};
